import styles from '../components/modals/configurations/configuration-email-set-modal.styl'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { EMAIL_TYPES } from '../constants/enums'

const NAME = '{name}'
const AWARD_LEADER_NAME = '{award_leader_name}'
const AWARD_LEADER_FN = '{award_leader_first_name}'
const AWARD_LEADER_EMAIL = '{award_leader_email}'
const PARTICIPANT_NAME = '{participant_name}'
const PARTICIPANT_FN = '{participant_first_name}'
const NOTE = '{note}'
const LINK = '{link}'
const AWARD_LVL = '{award_level_type}'
const ACTIVITY_NAME = '{activity_name}'
const ORG_NAME = '{organization_name}'
const AJ_CATEGORY_NAME = '{aj_event_category_type}'

const AWARD_LEADER_NAME_DESC = <FormattedMessage id="label.email_help_award_leader_full_name" defaultMessage="Award Leader full name." />
const AWARD_LEADER_FN_DESC = <FormattedMessage id="label.email_help_award_leader_first_name" defaultMessage="Award Leader first name." />
const AWARD_LEADER_EMAIL_DESC = <FormattedMessage id="label.email_help_award_leader_email" defaultMessage="Award Leader email." />
const PARTICIPANT_NAME_DESC = <FormattedMessage id="label.email_help_participant_full_name" defaultMessage="Participant full name." />
const PERSON_NAME_DESC = <FormattedMessage id="label.email_help_person_full_name" defaultMessage="Person full name." />
const PARTICIPANT_FN_DESC = <FormattedMessage id="label.email_help_participant_first_name" defaultMessage="Participant first name." />
const NOTE_DESC = <FormattedMessage id="label.email_help_note" defaultMessage="Custom note, if is set." />
const LINK_DESC = <FormattedMessage id="label.email_help_custom_link" defaultMessage="Custom link, if is set." />
const AWARD_LVL_DESC = <FormattedMessage id="label.email_help_award_level" defaultMessage="Award Level." />
const ACTIVITY_NAME_DESC = <FormattedMessage id="label.email_help_activity_name" defaultMessage="Name of the activity." />
const ORG_NAME_DESC = <FormattedMessage id="label.email_help_organization_name" defaultMessage="Name of the award centre." />
const AJ_CATEGORY_NAME_DESC = <FormattedMessage id="label.email_help_aj_category" defaultMessage="Adventure Journey category." />




export const getHelp = (type) => {

    let contentLeft
    let contentRight

    switch (type) {

        case EMAIL_TYPES.awardCompletionEmail.id:
            contentLeft = [
                <p><b>{PARTICIPANT_NAME}</b> - {PARTICIPANT_NAME_DESC}</p>,
                <p><b>{PARTICIPANT_FN}</b> - {PARTICIPANT_FN_DESC}</p>,
                <p><b>{AWARD_LVL}</b> - {AWARD_LVL_DESC}</p>,
                <p><b>{NOTE}</b> - {NOTE_DESC}</p>,
                <p><b>{"{1}"}</b> - {"Next level invitation link."}</p>,
                <p><b>{"{2}"}</b> - {"Digital badge URL."}</p>
            ]
            break
        case EMAIL_TYPES.awardCompletionEmailSurvey.id:
            contentLeft = [
                <p><b>{PARTICIPANT_NAME}</b> - {PARTICIPANT_NAME_DESC}</p>,
                <p><b>{PARTICIPANT_FN}</b> - {PARTICIPANT_FN_DESC}</p>,
                <p><b>{AWARD_LVL}</b> - {AWARD_LVL_DESC}</p>,
                <p><b>{NOTE}</b> - {NOTE_DESC}</p>,
                <p><b>{LINK}</b> - {LINK_DESC}</p>,
                <p><b>{"{2}"}</b> - {"Digital badge URL."}</p>
            ]

            contentRight = [
                <p><b>{"{1}"}</b> - {"Next level invitation link."}</p>
            ]
            break
        case EMAIL_TYPES.AwardLeaderRejectionEmail.id:
            contentLeft = [
                <p><b>{AWARD_LEADER_NAME}</b> - {AWARD_LEADER_NAME_DESC}</p>,
                <p><b>{PARTICIPANT_NAME}</b> - {PARTICIPANT_NAME_DESC}</p>,
                <p><b>{AWARD_LVL}</b> - {AWARD_LVL_DESC}</p>,
                <p><b>{NOTE}</b> - {"Note from Award Office stating why the Award has been returned for revision."}</p>
            ]
            break
        case EMAIL_TYPES.assessorWelcomeEmail.id:
            contentLeft = [
                <p><b>{"{0}"}</b> - {"Assessor name."}</p>,
                <p><b>{"{1}"}</b> - {"Assigned activity."}</p>,
                <p><b>{PARTICIPANT_NAME}</b> - {PARTICIPANT_NAME_DESC}</p>,
                <p><b>{AWARD_LEADER_NAME}</b> - {AWARD_LEADER_NAME_DESC}</p>,
                <p><b>{AWARD_LEADER_EMAIL}</b> - {AWARD_LEADER_EMAIL_DESC}</p>
            ]
            break
        case EMAIL_TYPES.awardRegistrationApprovalEmail.id:
            contentLeft = [
                <p><b>{PARTICIPANT_NAME}</b> - {PARTICIPANT_NAME_DESC}</p>,
                <p><b>{AWARD_LVL}</b> - {AWARD_LVL_DESC}</p>
            ]
            break
        case EMAIL_TYPES.awardRegistrationApprovalEmailSurvey.id:
            contentLeft = [
                <p><b>{PARTICIPANT_NAME}</b> - {PARTICIPANT_NAME_DESC}</p>,
                <p><b>{AWARD_LVL}</b> - {AWARD_LVL_DESC}</p>,
                <p><b>{LINK}</b> - {LINK_DESC}</p>
            ]
            break

        case EMAIL_TYPES.activityAssessmentRequestEmail.id:
            contentLeft = [
                <p><b>{"{0}"}</b> - {"Assessor name."}</p>,
                <p><b>{"{1}"}</b> - {"Activity section and category."}</p>,
                <p><b>{PARTICIPANT_NAME}</b> - {PARTICIPANT_NAME_DESC}</p>,
                <p><b>{ORG_NAME}</b> - {ORG_NAME_DESC}</p>,
                <p><b>{LINK}</b> - {LINK_DESC}</p>
            ]
            break

        case EMAIL_TYPES.ajAssessmentRequestEmail.id:
            contentLeft = [
                <p><b>{"{0}"}</b> - {"Assessor name."}</p>,
                <p><b>{"{1}"}</b> - {"Adventure Journey event category name."}</p>,
                <p><b>{"{2}"}</b> - {"Adventure Journey event activity category name."}</p>,
                <p><b>{PARTICIPANT_NAME}</b> - {PARTICIPANT_NAME_DESC}</p>,
                <p><b>{ORG_NAME}</b> - {ORG_NAME_DESC}</p>,
                <p><b>{LINK}</b> - {LINK_DESC}</p>
            ]
            break

        case EMAIL_TYPES.rpAssessmentRequestEmail.id:
            contentLeft = [
                <p><b>{"{0}"}</b> - {"Assessor name."}</p>,
                <p><b>{"{1}"}</b> - {"Residential project activity section and category name."}</p>,
                <p><b>{PARTICIPANT_NAME}</b> - {PARTICIPANT_NAME_DESC}</p>,
                <p><b>{ORG_NAME}</b> - {ORG_NAME_DESC}</p>,
                <p><b>{LINK}</b> - {LINK_DESC}</p>
            ]
            break

        case EMAIL_TYPES.awardLeaderConfirmationSignoffEmail.id:
            contentLeft = [
                <p><b>{AWARD_LEADER_NAME}</b> - {AWARD_LEADER_NAME_DESC}</p>,
                <p><b>{PARTICIPANT_NAME}</b> - {PARTICIPANT_NAME_DESC}</p>,
                <p><b>{LINK}</b> - {LINK_DESC}</p>
            ]
            break

        case EMAIL_TYPES.participantNextLevelInvitationEmail.id:
            contentLeft = [
                <p><b>{"{0}"}</b> - {"The name of the person who created the invitation."}</p>,
                <p><b>{PARTICIPANT_NAME}</b> - {PARTICIPANT_NAME_DESC}</p>,
                <p><b>{LINK}</b> - {"The invitation link."}</p>
            ]
            break

        case EMAIL_TYPES.parentalConsentEmail.id:
            contentLeft = [
                <p><b>{"{0}"}</b> - {"Payment type."}</p>,
                <p><b>{PARTICIPANT_NAME}</b> - {PARTICIPANT_NAME_DESC}</p>,
                <p><b>{LINK}</b> - {"The invitation link."}</p>
            ]
            break

        case EMAIL_TYPES.participantArchivingEmail.id:
            contentLeft = [
                <p><b>{PARTICIPANT_NAME}</b> - {PARTICIPANT_NAME_DESC}</p>,
                <p><b>{LINK}</b> - {"Account re-activation link."}</p>
            ]
            break


        case EMAIL_TYPES.participantRegistrationDeletionEmail.id:
            contentLeft = [
                <p><b>{"{0}"}</b> - {PARTICIPANT_NAME_DESC}</p>,
                <p><b>{AWARD_LVL}</b> - {AWARD_LVL_DESC}</p>,
                <p><b>{ORG_NAME}</b> - {ORG_NAME_DESC}</p>
            ]
            break

        case EMAIL_TYPES.awardLeaderRegistrationConfirmationEmail.id:
            contentLeft = [
                <p><b>{AWARD_LEADER_NAME}</b> - {AWARD_LEADER_NAME_DESC}</p>
            ]
            break

        case EMAIL_TYPES.awardLeaderRegistrationConfirmationDeclinedEmail.id:
            contentLeft = []
            break

        case EMAIL_TYPES.createRoleInvitationEmail.id:
            contentLeft = [
                <p><b>{NAME}</b> - {PERSON_NAME_DESC}</p>,
                <p><b>{"{0}"}</b> - {"Link to reset password."}</p>,
                <p><b>{"{1}"}</b> - {"ORB web address."}</p>
            ]
            break

        case EMAIL_TYPES.parentalConsentInfoEmail.id:
            contentLeft = []
            break

        case EMAIL_TYPES.paymentReceiptEmail.id:
            contentLeft = []
            break

        case EMAIL_TYPES.resetPasswordEmail.id:
            contentLeft = [
                <p><b>{PARTICIPANT_NAME}</b> - {PARTICIPANT_NAME_DESC}</p>,
                <p><b>{LINK}</b> - {"Link to reset password."}</p>
            ]
            break

        case EMAIL_TYPES.loginChangeRequestEmail.id:
            contentLeft = [
                <p><b>{LINK}</b> - {"Verification link."}</p>
            ]
            break

        case EMAIL_TYPES.addressChangeNewEmail.id:
            contentLeft = [
                <p><b>{PARTICIPANT_NAME}</b> - {PARTICIPANT_NAME_DESC}</p>
            ]
            break

        case EMAIL_TYPES.addressChangePreviousEmail.id:
            contentLeft = []
            break

        default:
            break
    }

    return (<div>
        <span> <FormattedMessage id="label.custom_parameters" defaultMessage='Custom parameters' /></span>
        <div style={{ clear: 'both' }}></div>
        <div className={styles.helpBlocks}>
            <div className={styles.helpLeftBlock} >
                {contentLeft}
            </div>
            <div className={styles.helpRightBlock}>
                {contentRight}
            </div>
            <div style={{ clear: 'both' }}></div>
        </div>

    </div>)
}

